import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from "react-bootstrap";

import axios from "axios";

const VerifyEmailScreen = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');

    const config = {
        header: {
          "Content-Type": "application/json",
        },
    };
  
    axios.post(
        "/auth/verify-email/" + token,
        config
    ).then(
        ( response ) => {
            if ( response.status === 200 ) {
                setMessage("Email address successfully verified! You may now login.");
            } else {
                setMessage("Invalid or expired token");
            }
        }
    ).catch(
        ( error ) => {
            console.log(error);
            setMessage("Internal server error");
        }
    )
  }, []);

  return (
    <Container className="auth-page">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="auth-card">
            <Card.Body>
              <h3 className="page-title">Email Verification</h3>
              <p className="mb-0">{message}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default VerifyEmailScreen;
